import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton } from '@fluentui/react';

const BaseDialog = ({ title = 'Please Confirm', text, content, hidden, buttons, onDismiss }) => (
  <Dialog
    hidden={hidden}
    onDismiss={onDismiss}
    dialogContentProps={{
      type: DialogType.normal,
      title,
      subText: text
    }}
    modalProps={{
      isBlocking: true,
    }}
  >
    {content}
    <DialogFooter>
      {
        buttons.map(({ isPrimary, ...rest }, index) => isPrimary
          ? <PrimaryButton key={index} {...rest} />
          : <DefaultButton key={index} {...rest} />)
      }
    </DialogFooter>
  </Dialog>
);

const ConfirmDialog = ({ title = 'Please Confirm', text, hidden, onConfirm, onDismiss}) => (
  <BaseDialog
    title={title}
    text={text}
    hidden={hidden}
    onDismiss={onDismiss}
    buttons={[
      { text: 'Delete', onClick: onConfirm, isPrimary: true },
      { text: 'Cancel', onClick: onDismiss, isPrimary: false }
    ]}
  />
);

export const CloseDialog = ({ title = 'Save Changes?', text, content, hidden, onSave, disableSave, onForget, onDismiss }) => (
  <BaseDialog
    title={title}
    text={text}
    content={content}
    hidden={hidden}
    onDismiss={onDismiss}
    buttons={[
      { text: 'Save', onClick: onSave, isPrimary: true, disabled: !!disableSave },
      { text: `Don't Save`, onClick: onForget, isPrimary: false },
    ]}
  />
);

ConfirmDialog.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
  hidden: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default ConfirmDialog;